/* eslint-disable no-template-curly-in-string */
import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    myStake: 'My Stake',
    description: '{amount} {token}',
    amountUsd: '/ ${amountUsd}',
    stakedToken: 'Staked {token} <b>{percent}%</b>',
    nonStakedToken: 'Non-Staked {token} <b>{percent}%</b>',
    boostedApy: 'Boosted APY {value}%',
    stakingApy: 'Staking APY {value}%',
  },
};
